export type RenderExtensionLoaderNotFound = 'RenderExtensionLoaderNotFound'
export const RenderExtensionLoaderNotFound = 'RenderExtensionLoaderNotFound' as RenderExtensionLoaderNotFound

export type ExtensionPointNotFound = 'ExtensionPointNotFound'
export const ExtensionPointNotFound = 'ExtensionPointNotFound' as ExtensionPointNotFound

export type ExtensionPointError =
  | ExtensionPointNotFound
  | RenderExtensionLoaderNotFound
